import PropTypes from "prop-types";
import "../../dashboard-cme/dashboard-cme.scss";
import React, { useState, useEffect, useContext } from "react";
import { useAccordionToggle, } from 'react-bootstrap/AccordionToggle';
import { Accordion, AccordionContext, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { getLastUpdatedDateColor, getLastUpdatedTootlTip, useSortableData } from "../../dashboard-util/dashboard-utils";
import ArrowDown from "../../../../assets/icons/ArrowDown.svg";
import ArrowUp from "../../../../assets/icons/ArrowUp.svg";
import ArrowHover from "../../../../assets/icons/ArrowHover.svg";
import ViolationIcon from "../../../../assets/icons/Icon-Complete-56px-Gold-50.svg";
import DownChevron from "../../../../assets/icons/Down_Chevron_20px_Black.svg";
import RightChevron from "../../../../assets/icons/Right_Chevron_20px_Black.svg";

import ViewMembersPanelNew from "../../../../components/view-members-new/view-members-new";
import CMEMemberModal from "./cme-member-modal";
import { DashboardExport } from "../../../../assets/icons";
import { GetCMEProjectTimeLogExcelExport } from "../../../../services/api/dashboard-api";

const CMEProjectTimeLog = (props) => {
    const [projects, setProjects] = useState(props.items ? props.items : null);
    const [show, setShow] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const { items, requestSort, getArrowDirectionFor } = useSortableData(projects);

    useEffect(() => {
        if (props.items) setProjects(props.items);
    }, [props]);

    const showModal = (m) => {
        setShow(true);
        setSelectedProject(m)
    }

    const onHide = () => {
        setShow(true);
        setSelectedProject(null)
    }

    const renderProjectTable = (projectList, isDormant) => {
        return (
            <div className="scrollable-dashboard">
            <table className="CMEDashboardTable">
                <thead className="MemberTableColumnHeader cmeHeader sticky-header-dashboard">
                    <tr className="tableColumnTitles tableHeader">
                        {
                            projectList[0]?.ProjectDynamicFields?.map((dynamicColumns, index) => {
                                return (
                                    index == 0
                                        ?
                                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                            <div onClick={() => requestSort(isDormant ? "CMEdormant" : "CMEactive")}  className={'sortedCenter'}>
                                                <div className="containerTextSorted">
                                                    <p className="textSorted">{dynamicColumns?.Label}</p>
                                                </div>
                                                {
                                                    getArrowDirectionFor(isDormant ? "CMEdormant" : "CMEactive", "descending") && (
                                                        <img className="arrowDirection" alt="Arrow down" src={ArrowDown} />
                                                    )
                                                }
                                                {
                                                    getArrowDirectionFor(isDormant ? "CMEdormant" : "CMEactive", "ascending") && (
                                                        <img className="arrowDirection" alt="Arrow up" src={ArrowUp} />
                                                    )
                                                }
                                                {
                                                    getArrowDirectionFor(isDormant ? "CMEdormant" : "CMEactive") && (
                                                        <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover} />
                                                    )
                                                }
                                            </div>
                                        </th>
                                        :
                                        index == 1
                                            ?
                                            <>
                                                <th className="col-md-3 col-sm-3 textEllipsis headerSorted">Project Name</th>
                                                <th className="col-md-3 col-sm-3 textEllipsis headerSorted">Members</th>
                                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">   {dynamicColumns?.Label}</th>
                                            </>
                                            :
                                            index == 6
                                                ? <>
                                                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">M-F Hours</th>
                                                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Saturday Hours</th>
                                                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Sunday hours</th>
                                                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Total Hours</th>
                                                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                                        {dynamicColumns?.Label}
                                                    </th>
                                                </>
                                                :
                                                <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                                    {dynamicColumns?.Label}
                                                </th>
                                )
                            })
                        }
                        <th className="col-md-1 col-sm-1 textEllipsis headerSorted">Description</th>
                        {getLastUpdatedTootlTip(<th className="col-md-1 col-sm-1 textEllipsis headerSorted">Last Updated</th>)}
                    </tr>
                </thead>
                <tbody className="tableBody cmeBody">
                    {projectList.length > 0 &&
                        projectList.map((active) => {
                            return (
                                <tr key={active?.DashboardKey} className={isDormant ? "dormantRow" : active?.IsViolation ? "isViolation" : ""}>
                                    {active?.ProjectDynamicFields?.length > 0 &&
                                        active?.ProjectDynamicFields?.map((d, index) => {
                                            return (
                                                index == 0
                                                    ?
                                                    <td className={`col-md-2 col-sm-1 mt-2 ${!isDormant ? "hover " : ""}`}
                                                        onClick={() => { if (!isDormant) showModal(active) }}>
                                                        <div className="violationContainer">
                                                            <div className="violationIconContainer">
                                                                {
                                                                    (!isDormant && active?.IsViolation) &&
                                                                    <OverlayTrigger
                                                                        placement={"bottom-start"}
                                                                        delay={{ show: 150, hide: 150 }}
                                                                        overlay={
                                                                            <Tooltip>
                                                                                Violation
                                                                            </Tooltip>
                                                                        }>
                                                                        <img src={ViolationIcon} className="violationIcon">
                                                                        </img>
                                                                    </OverlayTrigger>
                                                                }
                                                            </div>
                                                            {d.Data}
                                                        </div>
                                                    </td>
                                                    : index == 1
                                                        ?
                                                        <>
                                                            <td className="col-md-1 col-sm-1 mt-2">
                                                                {active.Project?.Name}
                                                            </td>
                                                            <td className="col-md-3 col-sm-3 mt-3 cmeMemberColumn">
                                                                    <ViewMembersPanelNew
                                                                        UserID={active.Project?.Owner?.Id}
                                                                        members={active.Project?.Members}
                                                                        projects={active.Project}
                                                                        isHidden={true}
                                                                    ></ViewMembersPanelNew>
                                                            </td>

                                                            <td className="col-md-1 col-sm-1 mt-2">
                                                                {d.Data}
                                                            </td>
                                                        </>
                                                        :
                                                        index == 6
                                                            ?
                                                            <>
                                                                <td className="col-md-1 col-sm-1 mt-2">
                                                                    {active.AggregateMFHours}
                                                                </td>
                                                                <td className="col-md-1 col-sm-1 mt-2">
                                                                    {active.AggregateSaturdayHours}
                                                                </td>
                                                                <td className="col-md-1 col-sm-1 mt-2">
                                                                    {active.AggregateSundayHours}
                                                                </td>
                                                                <td className="col-md-1 col-sm-1 mt-2">
                                                                    {active.AggregateTotalHours}
                                                                </td>
                                                                <td className="col-md-1 col-sm-1 mt-2">
                                                                    {d.Data}
                                                                </td>
                                                            </>
                                                            :
                                                            <td className="col-md-1 col-sm-1 mt-2">
                                                                {d.Data}
                                                            </td>
                                            )
                                        })
                                    }
                                    <td className="col-md-1 col-sm-1 mt-2">
                                        {active.Description}
                                    </td>
                                    <td className="col-md-1 col-sm-1 mt-2" style={{ color: getLastUpdatedDateColor(active.LastUpdated) }}>
                                        {active.LastUpdated ?? "-"}
                                    </td>                                    
                                </tr>
                            );
                        })}
                </tbody>
            </table>
            {selectedProject &&
                <CMEMemberModal
                    item={selectedProject} show={show} onHide={onHide} >
                </CMEMemberModal>}
            </div>
        )
    }

    const DormantAccordian = ({ eventKey, callback }) => {
        const currentEventKey = useContext(AccordionContext);

        const decoratedOnClick = useAccordionToggle(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = currentEventKey === eventKey;

        return (
            <div onClick={decoratedOnClick} className="dormantHeader">
                {isCurrentEventKey ?
                    <><img src={DownChevron} className="dormantChevron"></img> <span>Dormant/Completed/Archived Projects ({projects?.Dormant?.length}) </span></>
                    :
                    <><img src={RightChevron} className="dormantChevron"></img> <span>Dormant/Completed/Archived Projects ({projects?.Dormant?.length})</span></>}
            </div>
        );
    }

    return (
        <div className="new-dashboard table-wrapper mt-4">
            <div className="DashboardTableWrapper CMEDashboard">
                <div>
                    <div className="DashboardTableHeader">
                        <th className="DashboardTableTitle">
                            Project Time Log
                            <div className="DashboardTableHeaderButtons">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Export Data</Tooltip>}
                                >
                                    <img src={DashboardExport} onClick={GetCMEProjectTimeLogExcelExport} alt="Export CME"/>
                                </OverlayTrigger>
                            </div>
                            <div className="subDepartmentTitle">GIB/CME</div>
                        </th>
                    </div>
                </div>
                {   projects?.Active.length > 0 &&
                    renderProjectTable(projects.Active, false)
                }
                <Accordion >
                    <div className="dormantContainer">
                        <DormantAccordian eventKey="0" />
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                {   projects?.Dormant.length > 0 &&
                                    renderProjectTable(projects.Dormant, true)
                                }
                            </Card.Body>
                        </Accordion.Collapse>
                    </div>
                </Accordion>
            </div>
        </div>
    );
};


CMEProjectTimeLog.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
          Project: PropTypes.shape({
            Id: PropTypes.number.isRequired,
            Name: PropTypes.string.isRequired,
            Owner: PropTypes.shape({
              Id: PropTypes.number.isRequired,
              Name: PropTypes.string.isRequired,
            }).isRequired,
            Members: PropTypes.arrayOf(
              PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Name: PropTypes.string.isRequired,
              })
            ).isRequired,
          }).isRequired,
          ProjectDynamicFields: PropTypes.arrayOf(
            PropTypes.shape({
              Label: PropTypes.string.isRequired,
              Data: PropTypes.string.isRequired,
            })
          ).isRequired,
          ProjectMembers: PropTypes.arrayOf(PropTypes.shape({
            UserId: PropTypes.string,
            IsViolation: PropTypes.bool,
            AnalystAssociate: PropTypes.string,
            MFHours: PropTypes.string,
            SaturdayHours: PropTypes.string,
            SundayHours: PropTypes.string,
            TotalHours: PropTypes.string,
            Workload: PropTypes.string,
            LastUpdated: PropTypes.string
        })),
          AggregateMFHours: PropTypes.string.isRequired,
          AggregateSaturdayHours: PropTypes.string.isRequired,
          AggregateSundayHours: PropTypes.string.isRequired,
          AggregateTotalHours: PropTypes.string.isRequired,
          Description: PropTypes.string.isRequired,
          LastUpdated: PropTypes.string,
          IsViolation: PropTypes.bool.isRequired,
        })
      ),
};

export default CMEProjectTimeLog;
